module.exports = __webpack_public_path__ + "static/media/medial-flexion-up-2.0632759c.png";